import type { MailListItemAnimation } from "owa-mail-list-item-animation-store";

export function invokeAnimationCallback(animation: MailListItemAnimation): void {
    animation.animationCallback?.();
}
